import script from "./BultoLocationMapCanvas.vue?vue&type=script&setup=true&lang=js"
export * from "./BultoLocationMapCanvas.vue?vue&type=script&setup=true&lang=js"

import "./BultoLocationMapCanvas.vue?vue&type=style&index=0&id=3cbd88e2&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3cbd88e2"]])

export default __exports__